// extracted by mini-css-extract-plugin
export default {"root":"TWeWICG","left":"D7CdBxz","right":"SqmVVQU","expanded":"AJd7ebd"};